import { getAttribute, getAttributeValue } from "../../../Utilities/Functions";

export const getDependentAttributeChanges = (
  attributes,
  listOptions,
  currentAttributeId,
) => {
  const changes = [];
  const pepStatus = getAttributeValue(getAttribute(attributes, "62"));
  changes.push({
    attributeIds: ["63", "64", "65", "66"],
    mandatoryKyc: false,
    mandatoryAml: pepStatus === "PEP identified",
  });

  const pubAuth = getAttributeValue(getAttribute(attributes, "30"));
  changes.push({
    attributeIds: ["32"],
    visible: pubAuth === "Yes",
  });

  const blocked = getAttributeValue(getAttribute(attributes, "24"));
  const sanctioned = getAttributeValue(getAttribute(attributes, "60"));
  changes.push({
    attributeIds: ["78"],
    mandatoryKyc: blocked === "Yes" || sanctioned === "Sanctioned",
    mandatoryAml: false,
    visible: blocked === "Yes" || sanctioned === "Sanctioned",
  });

  const regStatus = getAttributeValue(getAttribute(attributes, "26"));
  changes.push({
    attributeIds: ["27", "28"],
    visible: regStatus === "Yes",
  });

  if (regStatus === "Yes") {
    const regulatorAttr = getAttribute(attributes, "27");
    const options = (listOptions || {})[
      regulatorAttr.list_id || regulatorAttr.data_type
    ];
    if (options) {
      const regulatorCode = getAttributeValue(regulatorAttr);
      const regulator = options.find((e) => e.value === regulatorCode);
      changes.push({
        attributeIds: ["74"],
        userValue: regulator && regulator.equivalent ? "Yes" : "No",
      });
    }
  } else {
    changes.push({
      attributeIds: ["74"],
      userValue: "NA",
    });
  }

  const listingStatus = getAttributeValue(getAttribute(attributes, "18"));
  let isListed =
    listingStatus === "Yes(Client)" || listingStatus === "Yes(Ultimate Parent)";
  const exchange = getAttributeValue(getAttribute(attributes, "22"));
  if (!isListed && currentAttributeId === "22" && exchange) {
    changes.push({
      attributeIds: ["18"],
      userValue: "Yes(Client)",
    });
    isListed = true;
  }
  changes.push({
    attributeIds: ["20", "22"],
    visible: isListed,
  });
  if (isListed) {
    const exchangeAttr = getAttribute(attributes, "22");
    const options = (listOptions || {})[
      exchangeAttr.list_id || exchangeAttr.data_type
    ];
    if (options) {
      const exchangeCode = getAttributeValue(exchangeAttr);
      const exchange = options.find((e) => e.value === exchangeCode);
      changes.push({
        attributeIds: ["73"],
        userValue: exchange && exchange.equivalent ? "Yes" : "No",
      });
    }
  } else {
    changes.push({
      attributeIds: ["73"],
      userValue: "NA",
    });
  }
  return changes;
};
